import { ActionTree, GetterTree, MutationTree } from 'vuex';
import { KladrSubject } from '@/modules/backend/Entities/KladrSubject';
import { KladrQueryData } from '@/modules/backend/Dto/KladrQueryData';
import homeSmartApi from '@/plugins/HomeSmartApi';

interface State {
  items: KladrSubject[];
}

export const stateStore: State = {
  items: []
};

export const getters: GetterTree<State, unknown> = {
  items: (state) => state.items
};

export const mutations: MutationTree<State> = {
  replace: (state, payload: KladrSubject[]) => (state.items = payload)
};

export const actions: ActionTree<State, unknown> = {
  query: async ({ commit }, data: KladrQueryData) => {
    const subjects = await homeSmartApi.Kladr.query(data);
    commit('replace', subjects);
  }
};

export const address = {
  namespaced: true,
  state: stateStore,
  actions,
  getters,
  mutations
};
